<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <Shops :id="id" />
    <div class="save-group" >
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  components: {
    Shops: () => import("./Shops"),
  },
  data: () => ({
    cardLink: "organizations",
    cardSetLink: "organizations",
    item: null,
    fields: [

      {
        col: ' col-12 col-md-6',
        key: "name",
        label: "Название",
        type: "field",
        textType: "text",

      },
     
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
